import React, { useState, useEffect } from 'react';
import { linkgroup } from '../../pages/Home/JoinGroupV2';

const STORAGE_KEY = 'help24x7_dismissed_date';

// Returns true if user already dismissed today
function isDismissedToday() {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return false;
    return stored === new Date().toDateString();
}

// Floating 24/7 help button — shown on all pages except home
// User can close it; won't reappear until next day
function Help24x7() {
    const [visible, setVisible] = useState(!isDismissedToday());

    useEffect(() => {
        setVisible(!isDismissedToday());
    }, []);

    if (!visible) return null;

    function handleDismiss(e) {
        e.preventDefault();
        e.stopPropagation();
        localStorage.setItem(STORAGE_KEY, new Date().toDateString());
        setVisible(false);
    }

    return (
        <div className="fixed z-40 right-3 bottom-20 flex flex-col items-end gap-1">
            {/* Dismiss button */}
            <button
                onClick={handleDismiss}
                className="text-content-3 hover:text-content-2 text-xs self-end leading-none mb-0.5"
                aria-label="Đóng"
            >
                ✕
            </button>

            {/* Help link */}
            <a
                href={linkgroup.zaloSupport}
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-col items-center gap-1 group"
            >
                {/* Tooltip text */}
                <span className="text-xs text-content-3 whitespace-nowrap">
                    Bạn cần trợ giúp?
                </span>

                {/* Button circle */}
                <div className="w-12 h-12 bg-primary-500 rounded-full flex items-center justify-center hover:bg-primary-600 transition-colors">
                    {/* Headset icon */}
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 text-white" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 3a9 9 0 0 0-9 9v3.5A2.5 2.5 0 0 0 5.5 18H6a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1h-.93A7 7 0 0 1 19 12h-.07a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h.5a2.5 2.5 0 0 0 2.5-2.5V12a9 9 0 0 0-9-9z"/>
                    </svg>
                </div>
            </a>
        </div>
    );
}

export default Help24x7;
